import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
function Register({ onClose }) {
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [isLogin, setIsLogin] = useState(true);
  const handleCircleClick = (index) => {
    setFocusedIndex(index);
  };
  const circles = [
    { imageSrc: "/img/Franchisor.png", alt: "Franchisor", label: "Franchisor" },
    { imageSrc: "/img/Invester.png", alt: "Investor", label: "Investor" },
    {
      imageSrc: "/img/Channel partner.png",
      alt: "Channel Partner",
      label: "Channel Partner",
    },
  ];
  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm xl:px-5 lg:px-5 md:px-5 px-5">
        <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
          <div
            className="text-center mx-4 cursor-pointer"
            onClick={() => setIsLogin(false)}
          >
            <h2
              className={`text-xl font-medium mb-2 ${!isLogin ? "text-text_color" : "text-text_color"
                }`}
            >
              Register
            </h2>

            <hr className="border-b border-gray-400 w-28 mx-auto" />

          </div>
          <div className="text-center mt-3">
            <h2 className="text-xl font-medium mb-4">Select User Type</h2>
            <div className="flex flex-col md:flex-row md:justify-around gap-4">
              {circles.map((circle, index) => (
                <div
                  key={index}
                  className={`text-center relative ${index === focusedIndex ? "border-black" : ""
                    }`}
                >
                  <div
                    className={`rounded-full border border-[#7e8c99] w-24 h-24 mx-auto mb-2 flex items-center justify-center cursor-pointer ${index === focusedIndex ? "border-black" : ""
                      }`}
                    onClick={() => handleCircleClick(index)}
                  >
                    <img
                      src={circle.imageSrc}
                      alt={circle.alt}
                      className={`w-16 h-16 ${index === focusedIndex ? "filter-black" : ""
                        }`}
                    />
                    {index === focusedIndex && (
                      <div className="absolute md:top-0 md:right-0 right-32 hidden sm:block ">
                        <FaCheckCircle className="text-black-300 text-3xl rounded-full bg-white p-1" />
                      </div>
                    )}
                  </div>
                  <p>{circle.label}</p>
                </div>
              ))}
            </div>
            <div className="flex justify-center mt-5">
              <div className="bg-primaryColor rounded-md w-32 [transition:all_.15s_ease-in-out]">
                <NavLink
                  to={focusedIndex == 0 ? "/franchiser" :
                    focusedIndex == 1
                      ? "/Investor" : focusedIndex == 2 &&
                      "/channelpartnerregistration"
                  }
                >
                  <button
                    className="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
                    onClick={() => {
                      onClose()
                      // onClose(); focusedIndex == 0 
                      //   && dispatch(setModal(true))
                    }}
                  >
                    Next
                  </button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export default Register;
